import { render, staticRenderFns } from "./IdeaTypeCard.vue?vue&type=template&id=8cba4878&scoped=true"
import script from "./IdeaTypeCard.vue?vue&type=script&lang=js"
export * from "./IdeaTypeCard.vue?vue&type=script&lang=js"
import style0 from "./IdeaTypeCard.vue?vue&type=style&index=0&id=8cba4878&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cba4878",
  null
  
)

export default component.exports